import Highcharts from 'highcharts';

import { plural, singular } from '@/utils/format/label';

import Style from '../../styles-charts';

export function getThroughputChartConfig({
  data,
  title,
  levelLabels,
}: {
  data: any[];
  title: string;
  levelLabels: [string, string];
}): Highcharts.Options {
  return {
    chart: {
      type: 'column',
      ...Style.chart,
    },
    title: {
      text: title,
      style: { ...Style.chartTitle, fontSize: '16px' },
    },
    xAxis: {
      type: 'category',
      title: {
        text: 'SOH-C Range',
        style: Style.axisTitle,
      },
      gridLineColor: Style.chartColors.gridLine,
      labels: Style.axisLabel,
    },
    yAxis: {
      title: {
        text: `Number of ${plural(levelLabels)}`,
        style: Style.axisTitle,
      },
      allowDecimals: false,
      min: 0,
      gridLineColor: Style.chartColors.gridLine,
      labels: Style.axisLabel,
    },
    series: [
      {
        type: 'column',
        data,
        color: Style.chartColors.primary,
      },
    ],
    tooltip: {
      formatter: function () {
        if (this.y === 1) return `${this.y} ${singular(levelLabels)}`;
        return `${this.y} ${plural(levelLabels)}`;
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
  };
}
